class Home {
    constructor(data) {
        this.take = 10;
        this.page = data.page;
    }

    get() {
        this.buildFilters();
        return this.filters;
    }

    buildFilters() {
        this.filters = {
            'user_id': App.user.id,
            'reviewed': false,
            'not_reviewed': true,
            'order_recent_by_publish_date': true,
            'favorites_first': true,
            'add_separator': 'song_published_at',
            'only_of_user': false,
            'published': true,
            'uploader_id': null,
            'excluded_songs': App.user.songs_of_blocked_users,
            'only_received_as_suggestion': false,
            'take': this.take,
            'skip': (this.page - 1) * this.take,
        };

        // if (App.filters.available_in.length){
            this.filters.available_in = App.filters.available_in;
        // }

        if (App.filters.licensed_in.length){
            this.filters.licensed_in = App.filters.licensed_in;
        }

        // if (App.filters.genres.length){
            this.filters.genres = App.filters.genres;
        // }        
    }
}

export default Home;